import { ItemType } from "../types/data.types";
import {
  FilterPageState,
  IFilterLoaded,
  IFilter,
  IFilterOptions,
} from "../types/filters.types";

export const defaultFiltersLoaded: IFilterLoaded = {
  warehouseDivision: false,
  warehouse: false,
  distribution: false,
  dsdVendor: false,
  retailDivision: false,
  retailStore: false,
  smic: false,
  upc: false,
  cic: false,
  department: false,
  retailSection: false,
};

export const defaultFilters: IFilter = {
  warehouseDivision: "",
  warehouse: "",
  distribution: "",
  dsdVendor: "",
  retailDivision: "",
  retailStore: "",
  smic: "",
  upc: "",
  cic: "",
  department: "",
  retailSection: "",
};

export const defaultFilterOptions: IFilterOptions = {
  warehouseDivision: [],
  warehouse: [],
  distribution: [],
  dsdVendor: [],
  retailDivision: [],
  retailStore: [],
  smic: [],
  upc: [],
  cic: [],
  department: [],
  retailSection: [],
};

export const defaultFilterPageState: FilterPageState = {
  warehouseDivision: { page: 0, hasMore: false },
  warehouse: { page: 0, hasMore: false },
  distribution: { page: 0, hasMore: false },
  dsdVendor: { page: 0, hasMore: false },
  retailDivision: { page: 0, hasMore: false },
  retailStore: { page: 0, hasMore: false },
  smic: { page: 0, hasMore: false },
  upc: { page: 0, hasMore: false },
  cic: { page: 0, hasMore: false },
  department: { page: 0, hasMore: false },
  retailSection: { page: 0, hasMore: false },
};

export const defaultItemType: ItemType = { type: "UNIFIED", subType: "NA" };
